// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__-Enih","content":"LayoutSettings_content__UQUki"};